import React, { useEffect, useState } from 'react';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { Container } from '../../../../symphony';

import { SlLEContext } from '../../global-constants';
import { SlDataService } from '../../services/sl-data.service';
import { SlActions } from '../../services/ActionsService/sl-actions';
import { ActionType, RequestType } from '../../global-interface';
import { DeviceInfo } from '../../../../shared/public/SlUtils/detectDevice';
import { SlNotAllowedFeature } from '../../../../shared/public/SlNotAllowedFeature/SlNotAllowedFeature';

export function NotAllowedFeature(): JSX.Element {
	const [device, setDevice] = useState<DeviceInfo>(null);

	const { deviceInfo$ } = Container.take(SlLEContext, SlDataService);

	const closeWindow = (): void => {
		const actions$ = Container.take(SlLEContext, SlActions).actions$;

		actions$.next({
			type: ActionType.OnCloseNotAllowedFeatureModalClick,
			requestType: RequestType.Parallel,
		});
	};

	useEffect(() => {
		const unsubscriber = new Subject<void>();

		deviceInfo$.pipe(takeUntil(unsubscriber)).subscribe(setDevice);

		return () => {
			unsubscriber.next();
			unsubscriber.complete();
		};
	}, []);

	return device && device?.isMobile ? (
		<SlNotAllowedFeature os={device?.os} onCloseClick={closeWindow} />
	) : null;
}
